/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { useGetDataDashboard } from '../../../../app/hooks/dashboard';

type Props = {
  className: string
}

export const ChartsTotal: React.FC<Props> = ({className}) => {

  return (
    <div className={`card ${className}`}>
      <div className='card-body d-flex flex-column align-items-center justify-content-center'>
        <div className='d-flex flex-column gap-4'>
        <div className='d-flex flex-column gap-2'>
            <h3 className='text-left text-muted mb-0 mr-2'>Total Perangkat di Inventory</h3>
            <div className='d-flex align-items-center mb-2'>
              <i className='bi bi-music-player-fill fs-2x text-primary'></i>
              <h4 className='mb-0 fs-2x px-3'>300.000</h4>
            </div>
          </div>
          <div className='d-flex flex-column gap-2'>
            <h3 className='text-left text-muted mb-0 mr-2'>Total Perangkat Digunakan Ou</h3>
            <div className='d-flex align-items-center mb-2'>
              <i className='bi bi-music-player-fill fs-2x text-success'></i>
              <h4 className='mb-0 fs-2x px-3'>250.000</h4>
            </div>
          </div>
          <div className='d-flex flex-column gap-2'>
            <h3 className='text-left text-muted mb-0 mr-2 mt-2'>Total Perangkat Keseluruhan</h3>
            <div className='d-flex align-items-center'>
              <i className='bi bi-music-player-fill fs-2x text-danger'></i>
              <h4 className='mb-0 fs-2x px-3'>550.000</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );  
  
};


